
export default {
  props: {
    value: {
      type: [String, Number], // 빈 값 받기 위함
      default: 1
    },
    data: {
      type: Array,
      default: () => {
        return ['']
      }
    },
    useSlot: {
      type: Boolean,
      default: false
    },
    disabled: { // 전체 비활성화 필요 시
      type: Boolean,
      default: false
    },
    column: { // 세로 정렬
      type: Boolean,
      default: false
    },
    button: { // radio-button 사용
      type: Boolean,
      default: false
    },
    isCmmnCd: { // 공통코드 전용 라디오
      type: Boolean,
      default: false
    }
  },
  setup (props, ctx) {
    const change = newValue => ctx.emit(
      'change',
      newValue
    )
    return { change }
  },
  computed: {
    radioValue: {
      get () {
        return this.value
      },
      set (newValue) {
        this.change(newValue)
      }
    }
  },
  methods: {
  }
}
